export const favVersesKey = 'fav_verses';
export const playerSettingsKey = 'player_settings';
export const userSettingsKey = 'user_settings';
export const darkModeKey = 'dark_mode';
export const saveToDB = (data, key) => {
  localStorage.setItem(key, JSON.stringify(data));
};
export const getData = key => {
  const data = localStorage.getItem(key);

  return data ? JSON.parse(data) : [];
};
export const clearDB = () => {
  //clears the local storage data
  localStorage.clear();
};
/*

localStorage.setItem("player_settings", JSON.stringify(
{
 "volume":.75,
 "is_replay_on":true,
 "last_play_time":0
}));

localStorage.setItem("dark_mode", JSON.stringify({
  "status":true
}));


localStorage.setItem("user_settings", JSON.stringify(
{

 "last_selected_reciter_index":1,
 "last_played_verse_index":2,
 "reciters_and_fav_verses_indexes":[
    {
      "reciter_id_1":{
      "fav_list":[
        {"index":1},
        {"index":3},
        {"index":10}
      ],
      "info":{
        "name":"",
        "location":"",
        "info":"",
      }
    
    }
  },
  {
    "reciter_id_2":{
      "fav_list":[],
      "info":{
        "name":"",
        "location":"",
        "info":"",
      }
    
    }
  }

 ]

}));





 

"{\"volume\":0.1,\"last_played_verse\":\"israa\"}"
localStorage.setItem("player_settings", JSON.stringify(
{
 "volume":.75,
 "last_played_verse_index":1,
 "is_replay":true,
 "last_play_time":0,
 "last_selected_reciter_index":1

}));




localStorage.getItem("player_settings")
data
{
  "reciter_1":{
    "fav_list":
    [
    {index:1},
    {index:3},
    {index:10}

  ],
  "info":{}
  
  },

  "reciter_2":{
    
  }


}

localStorage.setItem("fav_verses", JSON.stringify(
{
  "reciter_1":[
    {index:1},
    {index:3},
    {index:10},
    {index:17}

  ],

  "reciter_2":[


  ],


}));



localStorage.getItem("fav_verses")
 */
